(function CheckForm() {
  'use strict';

  var MobileVerification = {
    requestOTP: '/tools/promoproxy/api/public/request-otp',
    verifyOTP: '/tools/promoproxy/api/public/verify-otp',
    registerAccount: '/tools/promoproxy/api/public/register',
  };

  var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  var otpCountdown = 0;
  var $otpCountdown = $('#otpCountdown');
  var $registerBtn = $('#btn-register');
  var otpTimer = 0;
  var $btnRequestOTP = $('#register-request-otp');
  var errorCodes = [];

  function prepareTagsToSubmit() {
    var tags = ['lang:|' + ($('html').attr('lang') || '') + '|'];
    $("input[id^='field-cb-']").each(function() {
      tags.push($(this).data('key') + ':' + ($(this).prop('checked') ? 'true' : 'false'));
    });
    var $referralInput = $("input[id='field-referral_code']");
    if ($referralInput.val()) {
      tags.push('referral:' + $referralInput.val());
    }
    return tags;
  }

  function onSubmitRegister(){

    $registerBtn.on('click', function(e){
      e.preventDefault();
      $registerBtn.attr('disabled', true);
      resetFormErrorInfo();

      var $pw = $('#field-password');
      var pattern1 = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?!.* ).{8,16}$/;

      var title = $.trim( $('#field-title').val() );
      var firstName = $.trim( $('#field-first_name').val() );
      var lastName = $.trim( $('#field-last_name').val() );
      var email = $.trim( $('#field-email').val() );
      var phone = $.trim( $('#field-mobile').val() );
      var otp = $.trim( $('#field-otp').val() );
      var dob = '';
      var dobYYYY = $.trim( $('#field-dob-year').val() );
      var dobMM = $.trim( $('#field-dob-month').val() );

      var pw = $.trim( $('#field-password').val() );

      var $errorField = null;
      if ( title == '' ) {
        $('#field-title').parents('.form-group').addClass('errors').find('.invalid-feedback').html( errorCodes[ 'miss-title' ] ).removeClass('hide');
        if (!$errorField) {
          $errorField = $('#field-title');
        }
      }
      if ( firstName == '' ) {
        $('#field-first_name').parents('.form-group').addClass('errors').find('.invalid-feedback').html( errorCodes[ 'miss-firstname' ] ).removeClass('hide');
        if (!$errorField) {
          $errorField = $('#field-first_name');
        }
      }
      if ( lastName == '' ) {
        $('#field-last_name').parents('.form-group').addClass('errors').find('.invalid-feedback').html( errorCodes[ 'miss-lastname' ] ).removeClass('hide');
        if (!$errorField) {
          $errorField = $('#field-last_name');
        }
      }

      // check email
      if ( email === '' ) {
        $('#field-email').parents('.form-group').addClass('errors').find('.invalid-feedback').html( errorCodes['miss-email'] ).removeClass('hide');
        if (!$errorField) {
          $errorField = $('#field-email');
        }
      }
      if ( emailRegex.test( email) !== true ) {
        $('#field-email').parents('.form-group').addClass('errors').find('.invalid-feedback').html( errorCodes['invalid-email'] ).removeClass('hide');
        if (!$errorField) {
          $errorField = $('#field-email');
        }
      }
      // check if phone entered
      if ( phone !== '' ) {
        if ( phone.length != 8 ){
          $('#field-mobile').parents('.form-group').addClass('errors');
          if (!$errorField) {
            $errorField = $('#field-mobile');
          }
        } else if ( otp.length != 6 ) {
          var isOTPSent = !$('#field-otp').parents('.form-group').hasClass('hide');
          if (isOTPSent) {
            $('#field-otp').parents('.form-group').addClass('errors');
            $('#field-otp').parents('.form-group').find('.invalid-feedback').html( errorCodes[ 'missing-otp' ] ).removeClass('hide');
            if (!$errorField) {
              $errorField = $('#field-otp');
            }
          } else {
            $('#field-mobile').parents('.form-group').addClass('errors');
            if (!$errorField) {
              $errorField = $('#field-mobile');
            }
          }
        }
      } else {
        $('#field-mobile').parents('.form-group').addClass('errors');
        if (!$errorField) {
          $errorField = $('#field-mobile');
        }
      }

      // check pw
      if ( pattern1.test($pw.val()) != true ) {
        $pw.parents('.form-group').addClass('errors');
        $pw.siblings('small').addClass('errors');
        if (!$errorField) {
          $errorField = $pw;
        }
      }
      if ( pw === '' ) {
        $('#field-password').parents('.form-group').addClass('errors');
        if (!$errorField) {
          $errorField = $('#field-password');
        }
      }

      // check if DOB entered
      if( dobYYYY !== '' || dobMM !== '' ){
        // either or both DOB fields filled
        if ( dobYYYY === '' ){
          $('#field-dob-year').parents('.col').addClass('has-errors').find('.invalid-feedback').html( errorCodes[ 'missing-dob-year' ] ).removeClass('hide');
          if (!$errorField) {
            $errorField = $('#field-dob-year');
          }
        } else if ( dobMM === '') {
          $('#field-dob-month').parents('.col').addClass('has-errors').find('.invalid-feedback').html( errorCodes[ 'missing-dob-month' ] ).removeClass('hide');
          if (!$errorField) {
            $errorField = $('#field-dob-month');
          }
        } else {
          dobYYYY = parseInt( dobYYYY );
          dobMM = parseInt( dobMM );
          dob = dobYYYY + '-' + dobMM;
        }
      }

      if( $errorField ) {
        scrollToErrorField($errorField);
        $registerBtn.attr('disabled', false);
        return false;
      } else {
        var acceptsMarketing = $('#field-accept_marketing').prop('checked') + '';
        if ( phone !== '' && phone.length!= "" ){
          // perform OTP verification
          var postData = {
            phone: phone,
            email: email,
            verification_code: otp
          };
          $.ajax({
            url: MobileVerification.verifyOTP,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            success: function( data ){
              console.log('OTP verify submitted');
              submitRegisterInfo({
                title: title,
                first_name: firstName,
                last_name: lastName,
                email: email,
                phone: phone,
                password: pw,
                birthday: dob,
                accepts_marketing: acceptsMarketing,
                tags: prepareTagsToSubmit(),
              });
            },
            error: function(xhr, status, error){
              console.log('testVerifyOTP fail');
              console.log(xhr.responseJSON);
              var errorCode = xhr.responseJSON ? xhr.responseJSON.errorCode : 0;
              $registerBtn.attr('disabled', false);
              switch( errorCode ){
                case 2001:
                  $('#field-otp').parents('.form-group').addClass('errors');
                  $('#field-email').parents('.form-group').addClass('errors');
                  $('#field-mobile').parents('.form-group').addClass('errors');
                  $('#field-otp').parents('.form-group').find('.invalid-feedback').html( errorCodes[ errorCode ] ).removeClass('hide');
                  scrollToErrorField($('#field-email'));
                  break;
                case 2002:
                  $('#field-mobile').parents('.form-group').addClass('errors');
                  $('#field-mobile').parents('.form-group').find('.invalid-feedback').html( errorCodes[ errorCode ] ).removeClass('hide');
                  scrollToErrorField($('#field-mobile'));
                  break;
                case 2003:
                case 2004:
                  $('#field-otp').parents('.form-group').addClass('errors');
                  $('#field-otp').parents('.form-group').find('.invalid-feedback').html( errorCodes[ errorCode ] ).removeClass('hide');
                  scrollToErrorField($('#field-otp'));
                  break;
                default:
                  $('.server-issue').removeClass('hide');
                  scrollToErrorField(null);
                  break;
              }
              return false;
            },
            data: JSON.stringify(postData)
          });
        } else {
          submitRegisterInfo({
            title: title,
            first_name: firstName,
            last_name: lastName,
            email: email,
            phone: '',
            password: pw,
            birthday: dob,
            accepts_marketing: acceptsMarketing,
            tags: prepareTagsToSubmit(),
          });
        }
      }

    });
  }

  function scrollToErrorField($errorField) {
    var $parent = $errorField
      ? $errorField.parents('.form-group')
      : $('form#create_customer');
    $('body,html').animate({
      scrollTop: $parent.offset().top - $('.site-header-container').outerHeight() - $('.breadcrumb').outerHeight()
    }, 1200);
  }

  function clearFieldError($target){
    $target.parents('.form-group').removeClass('errors').find('.invalid-feedback').addClass('hide').html('');
    $target.parents('.has-errors').removeClass('has-errors');
  }

  function resetFormErrorInfo() {
    // reset error
    $('#create_customer').find('.has-errors').removeClass('has-errors');
    $('#create_customer').find('.errors').removeClass('errors').find('.invalid-feedback').addClass('hide');
    $('#field-mobile').parents('.form-group').find('.invalid-feedback').addClass('hide');
    $('.server-issue').addClass('hide');
  }

  function _submitRegisterInfo(postData) {
    $.ajax({
      url: MobileVerification.registerAccount,
      type: 'post',
      dataType: 'json',
      contentType: 'application/json',
      success: function(){
        $('form#customer_login input[name="customer[email]"]').val(postData.email);
        $('form#customer_login input[name="customer[password]"]').val(postData.password);
        $('form#customer_login').submit();
      },
      error: function(xhr, status, error){
        console.log('testRegisterAccount fail');
        console.log(xhr.responseJSON);
        var errorCode = xhr.responseJSON ? xhr.responseJSON.errorCode : 0;
        $registerBtn.attr('disabled', false);
        switch( errorCode ){
          case 3001:
            $('#field-otp').parents('.form-group').addClass('errors');
            $('#field-email').parents('.form-group').addClass('errors');
            $('#field-mobile').parents('.form-group').addClass('errors');
            $('#field-otp').parents('.form-group').find('.invalid-feedback').html( errorCodes[ errorCode ] ).removeClass('hide');
            scrollToErrorField($('#field-email'));
            break;
          case 3002:
          case 3010:
            $('#field-email').parents('.form-group').addClass('errors').find('.invalid-feedback').html( errorCodes[ errorCode ] ).removeClass('hide');
            scrollToErrorField($('#field-email'));
            break;
          case 3003:
            var errorField = xhr.responseJSON.errorField;
            if (errorField.includes('email')) {
              $('#field-email').parents('.form-group').addClass('errors').find('.invalid-feedback').html( errorCodes['3003-email'] ).removeClass('hide');
              scrollToErrorField($('#field-email'));
            } else if (errorField.includes('password')) {
              $('#field-password').parents('.form-group').addClass('errors').find('.invalid-feedback').html( errorCodes['3003-password'] ).removeClass('hide');
              scrollToErrorField($('#field-password'));
            }
            break;
          case 3004:
          default:
            $('.server-issue').removeClass('hide');
            scrollToErrorField(null);
            break;
        }
        return false;
      },
      data: JSON.stringify(postData)
    });
  }

  function submitRegisterInfo(postData) {
    window.Shopify.captcha.protect(document.getElementById('customer_login'), () => {
      _submitRegisterInfo(postData);
    })
  }

  function runOTPCountdown() {
    if ( otpCountdown == 0 ) {
      otpCountdown = 60;
      $btnRequestOTP.addClass('counting').attr('disabled', true);
      updateOTPCountdown();
      otpTimer = setInterval(function(){
        updateOTPCountdown();
      }, 1000);
    }
  }

  function cancelOTPCountdown() {
    otpCountdown=1;
    updateOTPCountdown();
  }

  function updateOTPCountdown() {
    otpCountdown--;
    if ( otpCountdown ) {
      var txt = "";
      if ( otpCountdown <= 0 ) {
        clearInterval( otpTimer );
        otpCountdown = 0;
        $btnRequestOTP.removeClass('counting').attr('disabled', false);
      } else {
        txt = " ("+otpCountdown+")";
      }
      $otpCountdown.html( txt ).toggleClass('disp-ib', txt!=="");
    }
  }

  function initOTP() {
    // event handler for request OTP
    $btnRequestOTP.on('click', function(e){
      e.preventDefault();
      var $emailField = $('#field-email');
      var $phoneField = $('#field-mobile');
      var email = $.trim( $emailField.val() );
      var phone = $.trim( $phoneField.val() );
      // check email
      if ( email === '' ) {
        $emailField.parents('.form-group').addClass('errors');
        $emailField.parents('.form-group').find('.invalid-feedback').html( errorCodes['miss-email'] ).removeClass('hide');
        return false;
      }
      // check phone
      if ( phone === '' || phone.length != 8 ) {
        $phoneField.parents('.form-group').addClass('errors');
        return false;
      }

      $phoneField.parents('.form-group').find('.invalid-feedback').addClass('hide');
      $emailField.parents('.form-group').find('.invalid-feedback').addClass('hide');
      $('#create_customer').find('.errors').removeClass('errors');
      $('.server-issue').addClass('hide');
      $(this).attr('disabled', true);
      var postData = {
        phone: phone,
        email: email,
      };
      $.ajax({
        url: MobileVerification.requestOTP,
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        success: function( data ){
          console.log('OTP sent successfully');
          $phoneField.parents('.form-group').find('.valid-feedback').removeClass('hide');
          runOTPCountdown();
          $('#form-group-otp').removeClass('hide');
        },
        error: function(xhr, status, error){
          console.log('testRequestOTP fail');
          console.log(xhr.responseJSON);
          var errorCode = xhr.responseJSON ? xhr.responseJSON.errorCode : 0;
          cancelOTPCountdown();
          $('#form-group-otp').addClass('hide');
          switch( errorCode ){
            case 1001:
              showError('#field-email', errorCodes[ errorCode ]);
              break;
            case 1002:
            case 1003:
            case 1005:
            case 1006:
              showError('#field-mobile', errorCodes[ errorCode ]);
              break;
            case 1004:
              showError('#field-email', errorCodes[ 1001 ]);
              showError('#field-mobile', errorCodes[ 1002 ]);
              break;
            default:
              $('.server-issue').removeClass('hide');
              scrollToErrorField(null);
              break;
          }
        },
        data: JSON.stringify(postData)
      });
    });
  }

  function showError(fieldSelector, errMsg){
    $(fieldSelector).parents('.form-group').addClass('errors');
    $(fieldSelector).parents('.form-group').find('.valid-feedback').addClass('hide');
    $(fieldSelector).parents('.form-group').find('.invalid-feedback').html( errMsg ).removeClass('hide');
  }

  function loadErrorCodes() {
    $('.error-codes li').each(function(){
        var $li = $(this);
        errorCodes[$li.data('code')] = $li.html();
    });
    $('.error-codes').remove();
  }

  function initFormInteraction(){
    var $mobileField = $('#field-mobile');
    $mobileField.on('keyup', function(){
      var len = $(this).val();
      $btnRequestOTP.attr( 'disabled', (len.length!=8 || $btnRequestOTP.hasClass('counting')) );
      $mobileField.parent('.form-group').find('.valid-feedback').addClass('hide');
    });
  }

  function init(){
    onSubmitRegister();

    $('#field-mobile').on('keypress', function(e){
      return e.charCode >= 48 && e.charCode <= 57;
    })

    initOTP();
    loadErrorCodes();

    initFormInteraction();
    $('.pw-toggle').on('click', function(e){
      e.preventDefault();
      var $this = $(this);
      var $pw = $('#field-password');
      switch( $pw.attr('type') ){
        case 'password':
          $this.find('svg.icon-eye-slash').toggleClass('hide', true);
          $this.find('svg.icon-eye').toggleClass('hide', false);
          $pw.attr('type','text');
          break;
        case 'text':
          $this.find('svg.icon-eye-slash').toggleClass('hide', false);
          $this.find('svg.icon-eye').toggleClass('hide', true);
          $pw.attr('type','password');
          break;
      }
    });
    $('.form-control').on('change keydown', function(e){
      var $this = $(this);
      clearFieldError($this);
    });
  }
  init();
  return {};
})();
